var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "widget-title" },
      [
        _c("info-title", { staticClass: "d-inline-block" }, [
          _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
        ]),
        _vm._v(" "),
        _vm.subTitle
          ? _c("info-sub-title", [
              _vm._v("\n            " + _vm._s(_vm.subTitle) + "\n        ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.tooltip
          ? _c("help-popover", {
              staticClass: "d-inline-block",
              attrs: { content: _vm.tooltip }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "widget-content" },
      [
        _vm.widgetComponent && _vm.widgetData
          ? [
              _vm.widgetData.data.length !== 0
                ? _c(_vm.widgetComponent, {
                    tag: "component",
                    attrs: {
                      configuration: _vm.configuration,
                      data: _vm.widgetData
                    }
                  })
                : [_vm._v(_vm._s(_vm.resource("Chart_ErrorMessage_NoData")))]
            ]
          : _c("loader")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }